module.exports = __webpack_public_path__ + "media/images/realizacje/real13-8d92e1caf7d654a89516da63ff9ab386.png";